// extracted by mini-css-extract-plugin
export default {"container":"iz-z","dimension":"jz-z","dimensionLabels":"kz-z"};